<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Automation Testing</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>Automation Testing</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>Automation Testing</h3>
                    <p>Test automation services include test automation planning, tools selection, test environment
                        setup, test data
                        preparation, test scripts development and maintenance, test reporting.
                    </p>
                    <h3>Test Automation Benefits
                    </h3>
                    <p>
                        -20% testing cost,

                        -18% testing time,



                        Continuous testing within the CI/CD pipeline,



                        Zero severe defects in production,



                        Releases up to several times a day,
                    </p>

                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> Automated Functional Testing
                                    </li>
                                    <li><i class="flaticon-check"></i> The Problem</li>
                                    <li><i class="flaticon-check"></i> Automated Performance Testing</li>
                                    <li><i class="flaticon-check"></i> Automated Integration Testing</li>
                                    <li><i class="flaticon-check"></i> Automated Compatibility Testing</li>
                                    <li><i class="flaticon-check"></i> Automated Software Security Assurance</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/technology-expertise" class="active">Related Technology Expertise</a></li>
                        <li><a routerLink="/technology-expertise">Unit Test Cases</a></li>
                        <li><a routerLink="/technology-expertise">Bug Reports</a></li>
                        <li><a routerLink="/technology-expertise">Selenium</a></li>
                        <li><a routerLink="/technology-expertise">Java</a></li>
                        <li><a routerLink="/technology-expertise">JMeter</a></li>
                        <li><a routerLink="/technology-expertise">Jira</a></li>
                        <li><a routerLink="/technology-expertise">Azure Devops</a></li>
                    </ul>

                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/ui-testing-services">
                            <img src="assets/img/services/services-11.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/ui-testing-services">UI Testing</a>
                        </h3>
                        <span>Frontend Test</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/api-testing-services">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/api-testing-services">API Testing</a>
                        </h3>
                        <span>Using Tool</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/database-testing-services">
                            <img src="assets/img/services/services-10.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/database-testing-services">Database Testing</a>
                        </h3>
                        <span>Using Queries</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->